import { useEffect, useState } from 'react';

// Runtime site configuration (link visibility, promo state), managed from
// /admin without a redeploy. Defaults mirror the server's DEFAULT_CONFIG:
// if the fetch fails (dev server without functions, network hiccup), the
// site behaves exactly as it does today.
export const SITE_CONFIG_DEFAULTS = {
  links: {
    about: true,
    nights: true,
    believe: true,
    faq: true,
    yearinreview: true,
  },
  promo: {
    enabled: true,
    endsAt: '2026-08-14T00:00:00',
  },
};

const CACHE_KEY = 'rw-site-config';

function readCache() {
  try {
    const raw = window.sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function merge(cfg) {
  return {
    links: { ...SITE_CONFIG_DEFAULTS.links, ...(cfg && cfg.links) },
    promo: { ...SITE_CONFIG_DEFAULTS.promo, ...(cfg && cfg.promo) },
  };
}

export default function useSiteConfig() {
  // Start from the session cache when we have one so repeat page loads
  // don't flash default state before the fetch lands.
  const [config, setConfig] = useState(() => merge(readCache()));
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch('/.netlify/functions/site-config');
        if (!res.ok) throw new Error('bad status');
        const data = await res.json();
        if (!alive) return;
        setConfig(merge(data));
        try {
          window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch {}
      } catch {
        // Defaults already in place.
      } finally {
        if (alive) setLoaded(true);
      }
    })();
    return () => { alive = false; };
  }, []);

  return { config, loaded };
}
